import { Action } from 'redux'
import { isType } from 'ts-action'
import { IStrikeReducer } from 'models/Strike'
import {
  GetActiveStrikesCount,
  GetStrikes,
  ResetStrikes,
  StrikesFetching,
} from './actions'

const initialState: IStrikeReducer = {
  meta: {
    message: '',
    code: 0,
  },
  isFetching: false,
  data: [],
}

export const strikesReducer = (
  state = initialState,
  action: Action,
): IStrikeReducer => {
  if (isType(action, GetStrikes)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, StrikesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, GetActiveStrikesCount)) {
    const { payload } = action
    return {
      ...state,
      activeStrikesCount: payload,
    }
  }
  if (isType(action, ResetStrikes)) {
    return {
      ...initialState,
    }
  }

  return state
}
